import { useTranslation } from 'react-i18next';
import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import type { AnnouncementsTableProps } from './AnnouncementsTable';
import { AnnouncementOpenButton } from './AnnouncementOpenButton';
import { DeleteAnnouncementDialog } from './DeleteAnnouncementDialog';
import {
  AnnouncementStatusBadge,
  formatActivePeriod,
} from './announcementDisplay';

export const AnnouncementsTableMobile = ({
  announcements,
  onOpen,
  onDelete,
}: AnnouncementsTableProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      component="ul"
      aria-label={t('announcements.tableLabel') as string}
      spacing={12}
      sx={{ listStyle: 'none', p: 0, m: 0 }}
    >
      {announcements.map((announcement) => (
        <Card
          component="li"
          variant="primary"
          key={announcement.id}
          sx={{ '&:hover': { cursor: 'default' } }}
        >
          <Stack spacing={2}>
            <Box>
              <Typography variant="caption">
                {t('announcements.columnTitle')}
              </Typography>
              <Typography variant="body1" lang="en">
                {announcement.title}
              </Typography>
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption" component="p">
                {t('announcements.columnStatus')}
              </Typography>
              <AnnouncementStatusBadge status={announcement.status} />
            </Box>
            <Divider />
            <Box>
              <Typography variant="caption">
                {t('announcements.columnActivePeriod')}
              </Typography>
              <Typography variant="body1">
                {formatActivePeriod(t, announcement)}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 8,
                pt: 1,
              }}
            >
              <AnnouncementOpenButton
                announcement={announcement}
                onOpen={onOpen}
              />
              <DeleteAnnouncementDialog
                title={announcement.title}
                onConfirm={() => onDelete(announcement)}
                showText
              />
            </Box>
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
